<template>
    <div class="swiperanimer-box">
        <swiper ref="animerSwiper" :options="swiperOptions" class="mySwiper">
            <swiper-slide class='swiperSlider' v-for='(item,index) in swiperData' :key='index'
                :style='{backgroundImage:"url("+item.imgurl+")"}'>
                <div class="center-box">
                    <div class="number">{{'0'+(index+1)}}</div>
                    <div class="chinaCaption" v-html='item.caption'></div>
                    <div class="enCaption">{{item.title}}</div>
                </div>
                <div class="time-box" :class='{isShow:index==type}'>
                    COMPANY PHOTOS
                </div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
<script>
    export default {
        name: 'SwiperAnimer',
        data() {
            return {
                type: '',
                swiperData: [
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/%E7%BB%84%20772.jpg',
                        caption: '我们认为工作是一种乐趣<br/>相信自己并热爱自己所做的事情<br/>打磨自我，做高分玩家',
                        title: 'Passion'
                    },
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/%E7%BB%84%20775.jpg',
                        caption: '激情生活，用心做事',
                        title: 'Innovation'
                    },
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/bc075b47-b56f-4713-8884-f689cdf66817.jpg',
                        caption: '不是在工作，就是在学习的路上',
                        title: 'Growth'
                    },
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/9646f1d9-b813-41b6-a5bc-be5df32029d9.jpg',
                        caption: '优秀的人复制优秀的人<br/>他像一束光吸引着同类',
                        title: 'Cooperation'
                    },
                ],
                swiperOptions: {
                    autoplay: { //匀速滚动
                        delay: 5000, //间隔时间0秒
                        // stopOnLastSlide: false,
                        // disableOnInteraction: false, //触摸后仍然执行
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    speed: 2000,
                    // Some Swiper option/callback...
                },
            }
        },
        computed: {
            swiper() {
                return this.$refs.animerSwiper.$swiper
            }
        },
        mounted() {
            // console.log('Current Swiper instance object', this.swiper)
            // this.swiper.slideTo(3, 1000, false)
            let _this = this
            this.swiper.on('slideChange', function () {
                let that = this
                setTimeout(function () {
                    _this.type = that.activeIndex
                }, 2000)
                // alert(this.activeIndex)
            })
        }
    }
</script>
<style scoped>
    .swiperanimer-box {
        height: 1000px;
    }

    .mySwiper,
    .swiperSlider {
        width: 100%;
        height: 100%;
    }

    .swiperSlider {
        background: #666666 no-repeat center center;
        background-size: cover;
        /* position: relative; */
    }

    .center-box {
        position: absolute;
        top: 50%;
        right: 8.1%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        transform: translateY(-50%);
    }

    .number {
        font-size: 200px;
        font-weight: bold;
        color: rgba(241, 244, 246, 1);
    }

    .chinaCaption {
        font-size: 24px;
        line-height: 200%;
        text-align: right;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 14px;
    }

    .enCaption {
        font-size: 20px;
        font-weight: 400;
        color: rgba(204, 204, 204, 1);
    }

    .time-box {
        font-size: 20px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        position: absolute;
        top: 62%;
        transform: translateY(-50%);
        left: 8.1%;
    }

    .time-box::after {
        content: '';
        display: block;
        height: 2px;
        width: 0px;
        background-color: #ffffff;
        margin-top: 25px;
        transition: all 5s;
    }

    .isShow::after {
        width: 120px;
    }

    .mySwiper>>>.swiper-pagination {
        top: 68%;
        left: 85%;
        width: auto;
        height: 20px;

    }

    .mySwiper>>>.swiper-pagination-bullet-active {
        background-color: #ffffff;
    }

    @media(max-width: 995px){
        .swiperanimer-box {
            height: 80.4vw;
        }
        .number{
            font-size: 35px;
        }
        .chinaCaption{
            font-size: 16px;
        }

        .enCaption {
            font-size: 16px;
        }
        .time-box {
        font-size: 16px;
        display: none;
    }
    .swiper-button-prev,.swiper-button-next,.swiper-pagination{
        display: none;
    }
    }

    /* @media(max-width: 1023px) {
        .swiperanimer-box {
            height: 1800px;
        }

        .chinaCaption {
            font-size: 75px;
        }

        .enCaption {
            font-size: 50px;
        }
        .time-box {
        font-size: 50px;
    }
    } */
</style>


// WEBPACK FOOTER //
// src/components/base/swiperanimer.vue